(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsWashFacilityViewModel', facilityDetailsWashFacilityViewModelFactory);

  /** @ngInject */
  function facilityDetailsWashFacilityViewModelFactory(facilityUtils, modelUtils) {
    function FacilityDetailsWashFacilityViewModel(facilityPoint) {
      this._propertyMappings = {};
      this._propertyMappings[facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA] = 'currentTemperature';
      this._propertyMappings[facilityUtils.ActuatorReferences.OP_FILTER_DANI_RADA] = 'filterDaysCount';
      this._propertyMappings[facilityUtils.ActuatorReferences.OP_BOJLER_DANI_RADA] = 'boilerDaysCount';

      if (typeof facilityPoint !== 'undefined') {
        this.refresh(facilityPoint);
      }
    }

    FacilityDetailsWashFacilityViewModel.prototype.destroy = function () {

    };

    FacilityDetailsWashFacilityViewModel.prototype.refresh = function (facilityPointJson) {
      this.pointId = facilityPointJson.id;
      this.name = facilityPointJson.name;
      this.pointType = facilityPointJson.pointType;
      //todo implement
      this.weatherIcon = 'assets/icons/ic_wb_sunny_black_24px.svg';

      setFeedValue.call(this, facilityUtils.getFeed(facilityPointJson, facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA));
      setActuatorValue.call(this, facilityUtils.getActuator(facilityPointJson, facilityUtils.ActuatorReferences.OP_FILTER_DANI_RADA));
      setActuatorValue.call(this, facilityUtils.getActuator(facilityPointJson, facilityUtils.ActuatorReferences.OP_BOJLER_DANI_RADA));
    };

    FacilityDetailsWashFacilityViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    FacilityDetailsWashFacilityViewModel.prototype.refreshActuator = function (actuator) {
      setActuatorValue.call(this, actuator);
    };

    return FacilityDetailsWashFacilityViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }

    function setActuatorValue(actuator) {
      if (actuator !== null && this._propertyMappings[actuator.reference]) {
        this[this._propertyMappings[actuator.reference]]
          = modelUtils.parseActuatorCurrentValue(actuator.value, actuator.actuatorType);
      }
    }

  }
})();
